import CustomButtton from "../Button/CustomButtton";
import { group, newsframe, newsone, newsthree, newstwo } from "../../images/general";
import React from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import { constants } from "../../utils/constants";
import { BlogEntry } from "services/contentfulService";
import Blog from "../../components/Blog";


const NewsUpdates = () => {

  const { allContentfulBlog: recentNewsResponse } = useStaticQuery(graphql`
    query {
      allContentfulBlog(
        sort: { publishDate: DESC }
        limit: 3
      ) {
        nodes {
          category {
            category
          }
          title {
            title
          }
          featuredImage {
            file {
              url
            }
          }
          thumbnailImage {
            file {
              url
            }
          }
          id
          slug
          publishDate
        }
      }
    }
  `);

    const latestNews: Partial<BlogEntry>[] = recentNewsResponse?.nodes?.map((blog: any) => ({
    category: blog?.category?.category,
    featuredImage: blog?.featuredImage,
    thumbnailImage: blog?.thumbnailImage,
    slug: blog?.slug,
    publishDate: blog?.publishDate,
    title: blog?.title?.title
  })) || []

  return (
    <>
      <section className="bg-[#EEECE8]">
        <div className="container max-w-7xl px-4 mx-auto sm:py-24 py-16"               
              data-sal="slide-up"
              data-sal-delay="400"
              data-sal-easing="ease">
          <div className="sm:flex sm:justify-between items-center">
            <div className="">
              <h2 className="sm:text-[64px] text-[28px] font-cinzel text-[#2A2E31] uppercase font-bold sm:leading-[64px] leading-7">
                News & Updates
              </h2>
            </div>
            <div className="sm:block hidden">
              <Link to={constants.app_routes.news}>
                <CustomButtton text="More News" icon2={group}/>
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 sm:mt-24 mt-8">
          {latestNews?.map((blog) => (
                <Blog blog={blog} isLightTheme={true} />
              ))}
          </div>
          <div className="sm:hidden block mt-6">
          <Link to={constants.app_routes.news}>
                    <CustomButtton text="More News" icon2={group}/>
                    </Link>
            </div>
          {/* <div className="relative hidden 2xl:block">
            <img src={newsframe} className="absolute bottom-[102px] -left-40" />
          </div> */}
        </div>
      </section>
    </>
  );
};


export default NewsUpdates;
